// 导入路由组件
import NewTea from '../views/NewTea'
import Culture from '../views/Culture'
import Contact from '../views/Contact'
import Home from '../views/Home'
// 导入路由管理工具
import {RouteConfig} from 'react-router-config'
 
const routes:RouteConfig = [
  {
    path:'/',
    exact:true,
    component:Home
  },
  {
    path:'/newtea',
    exact:true,
    component:NewTea
  },
  {
    path:'/culture',
    exact:true,
    component:Culture
  },
  {
    path:'/contact',
    exact:true,
    component:Contact    
  }
]
 
export default routes;